/* eslint-disable no-barrel-files/no-barrel-files */

import { RolodexEntryType } from 'types'

import { DefaultResultCard, ResultCardProps } from './DefaultResultCard'
import { UnitResultCard } from './UnitResultCard'

export type ResultCardComponent = React.FC<ResultCardProps>

export const RESULT_CARD_REGISTRY: Partial<
  Record<RolodexEntryType, ResultCardComponent>
> = {
  [RolodexEntryType.UNIT]: UnitResultCard,
}

export const getResultCardComponent = (
  type: RolodexEntryType
): ResultCardComponent => {
  return RESULT_CARD_REGISTRY[type] || DefaultResultCard
}

export { DefaultResultCard, UnitResultCard }
export type { ResultCardProps }
